import { useQuery } from "react-query";
import axios from "infra/http";
import { PessoaContato } from "features/unidades/typings/unidade";

function useGetContatos(pessoaId: string) {
  return useQuery([`/v1/contato-${pessoaId}`], async () => {
    const res = await axios.get<PessoaContato[]>(`/v1/contato`, {
      params: {
        pessoaId,
      },
    });

    return res.data;
  });
}

export default useGetContatos;
